export const TEXTS = {
  vi: {
    title: 'Âm Dương Lịch Việt Nam',
    languageToggle: 'English',
    dailyCalendar: 'Lịch Ngày',
    calendar: 'Lịch',
    zodiac: 'Tử Vi',
    fengshui: 'Phong Thủy',
    favorites: 'Yêu Thích',
    addFavorite: 'Thêm yêu thích',
    removeFavorite: 'Bỏ yêu thích',
    solar: 'Dương Lịch',
    lunar: 'Âm Lịch',
    today: 'Hôm Nay',
    zodiacYear: 'Năm',
    zodiacSign: 'Chi',
    zodiacSignWestern: 'Cung Mệnh',
    element: 'Ngũ Hành',
    characteristic: 'Đặc Điểm',
    auspiciousHours: 'Giờ Hoàng Đạo',
    inauspiciousHours: 'Giờ Hắc Đạo',
    goodDirections: 'Hướng Tốt',
    badDirections: 'Hướng Xấu',
    monthNames: ['Tháng 1', 'Tháng 2', 'Tháng 3', 'Tháng 4', 'Tháng 5', 'Tháng 6', 'Tháng 7', 'Tháng 8', 'Tháng 9', 'Tháng 10', 'Tháng 11', 'Tháng 12'],
    dayNames: ['Thứ 2', 'Thứ 3', 'Thứ 4', 'Thứ 5', 'Thứ 6', 'Thứ 7', 'Chủ Nhật'],
    selectDate: 'Chọn một ngày để xem thông tin',
    lunarVerbose: 'Âm lịch chi tiết',
    holiday: 'Ngày Lễ',
    lunarDay: 'Ngày',
    lunarMonth: 'Tháng',
    lunarYear: 'Năm',
    lunarLeap: 'nhuận',
    zodiacAnimal: 'Con giáp',
    zodiacElement: 'Ngũ hành',
    zodiacTraits: 'Đặc điểm',
    zodiacPeriod: 'Giai đoạn',
    canChiYear: 'Thiên Can Địa Chi',
    canChiDayLabel: 'Ngày',
    canChiMonthLabel: 'Tháng',
    canChiYearLabel: 'Năm',
    auspiciousTitle: 'Giờ Hoàng Đạo hôm nay',
    goodHours: 'Giờ tốt',
    badHours: 'Giờ xấu',
    detailsTitle: 'Thông Tin Chi Tiết',
    loading: 'Đang tải dữ liệu...',
    officialHoliday: 'Ngày nghỉ chính thức',
    notes: 'Ghi chú',
    keyHolidaysTitle: 'Những Ngày Lễ Chính',
    noHolidays: 'Không có ngày lễ trong tháng',
    homeTabs: { calendar: '📅 Lịch Việt', bazi: '🔮 Tử Vi (Bazi)' },
    prevMonthAria: 'Tháng trước',
    nextMonthAria: 'Tháng sau',
    dayPrefix: 'Ngày',
    lunarMonthLabel: 'Tháng',
    lunarYearLabel: 'Năm',
    footerAnalyticsLabel: 'Google Analytics ID',
    footerPlaceholder: 'G-XXXXXXXXXX',
    footerStatusReady: 'Đã cấu hình',
    footerStatusPending: 'Chưa cấu hình'
  },
  en: {
    title: 'Vietnamese Lunar & Solar Calendar',
    languageToggle: 'Tiếng Việt',
    dailyCalendar: 'Daily Calendar',
    calendar: 'Calendar',
    zodiac: 'Zodiac',
    fengshui: 'Feng Shui',
    favorites: 'Favorites',
    addFavorite: 'Add to favorites',
    removeFavorite: 'Remove favorite',
    solar: 'Solar',
    lunar: 'Lunar',
    today: 'Today',
    zodiacYear: 'Year',
    zodiacSign: 'Animal Sign',
    zodiacSignWestern: 'Zodiac Sign',
    element: 'Element',
    characteristic: 'Characteristics',
    auspiciousHours: 'Auspicious Hours',
    inauspiciousHours: 'Inauspicious Hours',
    goodDirections: 'Good Directions',
    badDirections: 'Bad Directions',
    monthNames: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
    dayNames: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
    selectDate: 'Select a date to view details',
    lunarVerbose: 'Lunar date breakdown',
    holiday: 'Holiday',
    lunarDay: 'Day',
    lunarMonth: 'Month',
    lunarYear: 'Year',
    lunarLeap: 'leap',
    zodiacAnimal: 'Zodiac animal',
    zodiacElement: 'Element',
    zodiacTraits: 'Traits',
    zodiacPeriod: 'Period',
    canChiYear: 'Heavenly Stem & Earthly Branch',
    canChiDayLabel: 'Day',
    canChiMonthLabel: 'Month',
    canChiYearLabel: 'Year',
    auspiciousTitle: 'Today\'s auspicious hours',
    goodHours: 'Auspicious',
    badHours: 'Inauspicious',
    detailsTitle: 'Detailed Information',
    loading: 'Loading data...',
    officialHoliday: 'Public holiday',
    notes: 'Notes',
    keyHolidaysTitle: 'Key Holidays',
    noHolidays: 'No holidays this month',
    homeTabs: { calendar: '📅 Vietnam Calendar', bazi: '🔮 Astrology (Bazi)' },
    prevMonthAria: 'Previous month',
    nextMonthAria: 'Next month',
    dayPrefix: 'Day',
    lunarMonthLabel: 'Month',
    lunarYearLabel: 'Year',
    footerAnalyticsLabel: 'Google Analytics ID',
    footerPlaceholder: 'G-XXXXXXXXXX',
    footerStatusReady: 'Configured',
    footerStatusPending: 'Not configured'
  }
};

export const ZODIAC_EMOJI = {
  'Tý': '🐭',
  'Sửu': '🐮',
  'Dần': '🐯',
  'Mão': '🐰',
  'Thìn': '🐲',
  'Tỵ': '🐍',
  'Ngọ': '🐴',
  'Mùi': '🐏',
  'Thân': '🐒',
  'Dậu': '🐔',
  'Tuất': '🐶',
  'Hợi': '🐷'
};

export const WESTERN_ZODIAC_SYMBOLS = {
  'Bạch Dương': '♈',
  'Kim Ngưu': '♉',
  'Song Tử': '♊',
  'Cự Giải': '♋',
  'Sư Tử': '♌',
  'Xử Nữ': '♍',
  'Thiên Bình': '♎',
  'Bọ Cạp': '♏',
  'Nhân Mã': '♐',
  'Ma Kết': '♑',
  'Bảo Bình': '♒',
  'Song Cá': '♓'
};

export const SPECIAL_LUNAR_NOTES = {
  vi: {
    1: 'Ngày mồng một',
    15: 'Ngày Rằm'
  },
  en: {
    1: 'First day of lunar month',
    15: 'Full Moon Day'
  }
};
